import { useQuery } from '@tanstack/react-query';
import { getAllKpiDistributionsByType } from '@/api/kpi-distribution/kpi-distribution';
import { KpiObjectType } from '@/api/entities/kpi';

export const useGetAllKpiDistributionsByType = (
  type: KpiObjectType,
  languageCode: string,
) => {
  return useQuery({
    queryKey: ['getAllKpiDistributionsByType', type, languageCode],
    queryFn: () => getAllKpiDistributionsByType(type, languageCode),
  });
};
